import { selectUserNotifications } from "@/redux/auth/selectors";
import { BellOutlined } from "@ant-design/icons";
import { Avatar, Col, List, Row } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NotificationList = ({ selectedTab, closeDropdown }) => {
  const userNotifications = useSelector(selectUserNotifications);
  const navigate = useNavigate();
  const navigateTo = ({ link }) => {
    if (selectedTab === 2) {
      navigate(`${link}&scroll=true`);
      if (closeDropdown) {
        closeDropdown();
      }
      return;
    }
    navigate(link);
    if (closeDropdown) {
      closeDropdown();
    }
    return;
  };
  const filterData = () => {
    if (selectedTab === 1) {
      return userNotifications?.filter((item) => item?.type === "info");
    } else {
      return userNotifications?.filter((item) => item?.type === "message");
    }
  };
  return (
    <div className="notification-menu">
      <List
        dataSource={filterData()}
        renderItem={(item) => {
          let read = !item.status;
          return (
            <List.Item
              onClick={() => navigateTo({ link: item.navigateLink })}
              className={`notification-item ${!read ? "unread" : ""}`}
            >
              <List.Item.Meta
                avatar={
                  <Avatar
                    icon={<BellOutlined />}
                    className={`notification-avatar ${
                      read ? "read" : "unread"
                    }`}
                  />
                }
                title={
                  <Row gutter={8}>
                    <Col span={21}>
                      <span
                        className={`notification-message ${
                          read ? "read" : "unread"
                        }`}
                      >
                        {item.message}
                      </span>
                    </Col>
                    <Col span={3}>
                      {!read &&
                        (selectedTab === 1 ? (
                          <span className="notification-dot" />
                        ) : (
                          <span className="notification-dot-count">
                            {" "}
                            <div>{item.messageCount}</div>{" "}
                          </span>
                        ))}
                    </Col>
                  </Row>
                }
              />
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default NotificationList;
